import React from "react";
import "../footer/paginationFooter.css";

import { FaArrowRight, FaArrowLeft } from "react-icons/fa6";

const PaginationFooter = ({
  isPreviousActive,
  isNextActive,
  onPrevClick,
  onNextClick,
}) => {
  return (
    <div className="footer-container">
      <button
        className={`previous-button ${
          isPreviousActive ? "active" : "inactive"
        }`}
        onClick={() => {
          if (isPreviousActive) {
            onPrevClick();
          }
        }}
      >
        <FaArrowLeft />
        Sebelumnya
      </button>
      <button
        className={`next-button ${isNextActive ? "active" : "inactive"}`}
        onClick={() => {
          if (isNextActive) {
            onNextClick();
          }
        }}
      >
        Selanjutnya
        <FaArrowRight />
      </button>
    </div>
  );
};

export default PaginationFooter;
